import { useRef } from 'react';

// Returns a cached value (typically captured from state)
// that does not change on render or on state changes
export const useCached = <T, >(provider: () => T): T => {
    const ref = useRef<T>(provider());
    return ref.current;
};
